import { isNotEmpty } from "utils/validate";
export const getDefaultValue = (restrictions = {}, unit, defaultAttribute) => {
    const { Default } = restrictions;
    const unitToCompare = typeof unit === "object" && "value" in unit ? unit.value : unit;
    if (Array.isArray(Default)) {
        const defaultFromArray = Default.find((item) => item?.units === unit && item?.attribute === defaultAttribute);
        return defaultFromArray?.value;
    }
    else if (typeof Default === "object") {
        if (!isNotEmpty(Default.units) ||
            (isNotEmpty(unitToCompare) && Default.units === unitToCompare && Default.attribute === defaultAttribute)) {
            return Default.value;
        }
        return undefined;
    }
    return Default;
};
